// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const bannerAuthResource = '/merchant/notifications/active-banners-auth'
const bannerNoAuthResource = '/notifications/active-banners-no-auths'

export default {
  getActiveBannerAuth() {
    return OperationRepository.get(`${bannerAuthResource}`)
  },
  getActiveBannerNoAuth() {
    return OperationRepository.get(`${bannerNoAuthResource}`)
  },
}
